import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { systemPowerUsage },
} = loanFormModel;

export class SystemPowerUsageValidation implements ValidationSchema {
  public name: string = systemPowerUsage.name;
  public label: string = systemPowerUsage.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: 'This field is required',
    value: systemPowerUsage.required,
  };
  public nullable = false;
}
export default new Validation(new SystemPowerUsageValidation());
